import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "block uppercase font-semibold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "block uppercase font-semibold" }, "|", -1)
const _hoisted_3 = { class: "block uppercase font-semibold" }
const _hoisted_4 = { class: "flex" }

import { uniq } from 'lodash';
import { computed, Ref } from 'vue';
import { useRoute } from 'vue-router';

import { VOLTA_ID } from '@/entities/services/const';
import { useGetDevicesQuery } from '@/entities/device/hooks';
import { useGetInspectionsQuery } from '@/entities/inspection/hooks';
import { useGetServiceQuery } from '@/entities/services/hooks';
import { useGetInspectionGroupQuery } from '@/entities/inspection-group/hooks';

import {
  NkText,
  NkContainer,
  NkStack,
  NkBox,
  NkGroup,
  NkHeading,
  NkButton,
  NkEntry,
  NkBadge,
  NkInlineModal,
  NkGrid,
  NkCol,
} from '@/core/components';

import NkDeviceCard from '@/entities/device/components/device-card/NkDeviceCard.vue';
import NkInspectionTable from '@/entities/inspection/components/InspectionTable.vue';

import NkInspectionGroupDeleteForm
  from '@/entities/inspection-group/components/form/InspectionGroupDeleteForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkInspectionGroup',
  setup(__props) {

const route = useRoute();

const inspectionGroupQueryData: Ref = computed(() => ({ id: Number(route.params.inspectionGroup) }));
const hasInspectionGroupQueryData = computed(() => !!inspectionGroupQueryData.value.id);
const { data: currentInspectionGroup } = useGetInspectionGroupQuery(inspectionGroupQueryData, {
  enabled: hasInspectionGroupQueryData,
});

const isVolta = computed(() => currentInspectionGroup.value?.service === VOLTA_ID);

const serviceQueryData: Ref = computed(() => ({ id: currentInspectionGroup.value?.service }));
const hasServiceQueryData = computed(() => !!serviceQueryData.value?.id);
const { data: service } = useGetServiceQuery(serviceQueryData, {
  enabled: hasServiceQueryData,
});

const inspectionQueryData = computed(() => ({ ids: currentInspectionGroup.value?.inspections || [] }));
const hasInspectionQueryData = computed(() => !!inspectionQueryData.value.ids.length);
const { data: inspections } = useGetInspectionsQuery({ enabled: hasInspectionQueryData }, inspectionQueryData);

const devicesQueryData = computed(() => ({ ids: uniq(inspections.value?.filter(o => o.isLastInspection)?.map(o => o.device)) }));
const hasDevicesQueryData = computed(() => !!devicesQueryData.value.ids.length);
const { data: devices } = useGetDevicesQuery({ enabled: hasDevicesQueryData }, devicesQueryData);

const parentDevicesQueryData: Ref = computed(() => ({ ids: uniq(devices.value?.map(o => o.parent)) }));
const hasParentDevicesQueryData = computed(() => !!parentDevicesQueryData.value.ids.length);
const { data: parentDevices, isLoading: parentDeviceLoading } = useGetDevicesQuery({ enabled: hasParentDevicesQueryData }, parentDevicesQueryData);

const parentDevicesWithChildren = computed(() => parentDevices.value?.map(o => ({
  ...o,
  name: o.deviceValues.find(dv => dv.reference === 'name')?.value || '-',
  inspections: inspections.value?.filter(i => i.isLastInspection && o.subDevices.includes(i.device))?.map(i => i.id),
})));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkContainer), { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkStack), { spacing: 8 }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkBox), null, {
            default: _withCtx(() => [
              _createVNode(_unref(NkStack), { spacing: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkGroup), { position: "apart" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NkHeading), { type: "underlined" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Inspection id : " + _toDisplayString(_unref(route).params.inspectionGroup), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NkGroup), {
                        NkGroup: "",
                        spacing: 2
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NkInlineModal), {
                            title: _ctx.$t('inspection-group.action.delete'),
                            class: "max-w-screen-md"
                          }, {
                            content: _withCtx(({close}) => [
                              _createVNode(NkInspectionGroupDeleteForm, {
                                id: _unref(inspectionGroupQueryData).id,
                                onSubmitted: close
                              }, null, 8, ["id", "onSubmitted"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_unref(NkButton), {
                                type: "danger",
                                icon: "NkDelete"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('inspection-group.action.delete')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["title"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NkGroup), {
                    spacing: 4,
                    class: "bg-gray-100 p-2 text-xxs flex items-center w-fit"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, [
                        _createTextVNode(_toDisplayString(_ctx.$t('inspection.service.type')) + " : ", 1),
                        (_unref(service))
                          ? (_openBlock(), _createBlock(_unref(NkBadge), {
                              key: 0,
                              size: "sm",
                              plain: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(service).name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_2,
                      _createElementVNode("span", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_ctx.$t('inspection.inspections_number')) + " : ", 1),
                        _createVNode(_unref(NkBadge), {
                          size: "sm",
                          plain: "",
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(currentInspectionGroup)?.inspections.length || 0), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  (_unref(currentInspectionGroup)?.comment)
                    ? (_openBlock(), _createBlock(_unref(NkText), { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(currentInspectionGroup).comment), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(NkEntry), {
            title: _ctx.$t('misc.related_device')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_unref(currentInspectionGroup)?.device)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
              name: 'visionair-device',
              params: {
                device: _unref(currentInspectionGroup).device,
              }
            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(NkDeviceCard, {
                          type: 8,
                          hoverable: ""
                        })
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _withDirectives((_openBlock(), _createBlock(_unref(NkGrid), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parentDevicesWithChildren), (parentDevice) => {
                return (_openBlock(), _createBlock(_unref(NkCol), {
                  span: 6,
                  key: parentDevice.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NkEntry), {
                      title: _ctx.$t('inspection.item_inspection', {item: parentDevice.name})
                    }, {
                      default: _withCtx(() => [
                        _createVNode(NkInspectionTable, {
                          "inspection-ids": parentDevice.inspections,
                          "is-volta": _unref(isVolta)
                        }, null, 8, ["inspection-ids", "is-volta"])
                      ]),
                      _: 2
                    }, 1032, ["title"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })), [
            [_directive_loading, _unref(parentDeviceLoading)]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})